<template>
  <div class="section-feature-cards">
    <div class="feature-grid">
      <div
        v-for="(card, idx) in displayCards"
        :key="idx"
        class="feature-card"
        :style="{ background: card.bgColor }"
      >
        <div class="card-badge" :style="{ background: card.badgeColor }">
          {{ card.badge }}
        </div>
        <h3 class="card-title" :style="{ color: card.textColor }">
          {{ card.title }}
        </h3>
        <p class="card-description" :style="{ color: card.descColor }">
          {{ card.description }}
        </p>
        <span class="card-link" :style="{ color: card.linkColor }">
          더 알아보기 →
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// 기본 카드 데이터
const DEFAULT_CARDS = [
  {
    badge: '정품 인증서',
    badgeColor: '#2c2c2c',
    title: '정품 인증서로 시술 정보를 안전하고 간편하게',
    description: '위변조 불가능한 NFT 인증서로 환자 이력을 체계적으로 관리하세요',
    bgColor: '#f2f2f2',
    textColor: '#1a1a1a',
    descColor: '#666',
    linkColor: '#1677ff',
    icon: '',
    link: '',
  },
  {
    badge: 'AI 상담',
    badgeColor: '#ff8a0d',
    title: '환자 채팅 상담 AI가 대신해줘요',
    description: '반복 상담은 AI에게 맡기고, 더 중요한 일에 집중하세요',
    bgColor: '#ffc847',
    textColor: '#1a1a1a',
    descColor: '#333',
    linkColor: '#1a1a1a',
    icon: '',
    link: '',
  },
  {
    badge: 'CRM 마케팅',
    badgeColor: 'rgba(255,255,255,0.2)',
    title: '재방문을 높이는 CRM 마케팅',
    description: '환자 세분화 타겟팅으로 재방문율을 높이세요',
    bgColor: '#242424',
    textColor: '#fff',
    descColor: 'rgba(255,255,255,0.7)',
    linkColor: '#4096ff',
    icon: '',
    link: '',
  },
  {
    badge: '이벤트 마케팅',
    badgeColor: 'rgba(255,255,255,0.2)',
    title: '타겟 고객 대상 맞춤 브랜딩까지',
    description: '맞춤형 이벤트로 고객 참여를 이끌어내세요',
    bgColor: '#242424',
    textColor: '#fff',
    descColor: 'rgba(255,255,255,0.7)',
    linkColor: '#4096ff',
    icon: '',
    link: '',
  },
];

export default {
  name: 'SectionFeatureCards',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    displayCards() {
      if (this.data?.cards && this.data.cards.length) {
        return this.data.cards.map((card, idx) => ({
          ...DEFAULT_CARDS[idx] || DEFAULT_CARDS[0],
          ...card,
        }));
      }
      return DEFAULT_CARDS;
    },
  },
};
</script>

<style scoped>
.section-feature-cards {
  padding: 60px 24px;
  background: #fff;
}

.feature-grid {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.feature-card {
  border-radius: 20px;
  padding: 32px;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.card-badge {
  display: inline-block;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 12px;
  margin-bottom: 16px;
  align-self: flex-start;
}

.card-title {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 8px;
}

.card-description {
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 16px;
  flex: 1;
}

.card-link {
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
</style>
